import { withErrorBoundary } from "@sentry/nextjs";
import { gql } from "graphql-request";
import { FC } from "react";
import styled from "styled-components";
import { Features25CommitteeContent } from "types/graphql/generated";
import { Employee } from "./Employee";

interface Props {
  className?: string;
  content: Features25CommitteeContent;
}

const Committee: FC<Props> = withErrorBoundary(({ content: { title, element }, className = "" }) => {
  return (
    <StyledCommittee className={className}>
      <h4 className="Features25__committeeTitle Font_24_32_600">{title}</h4>
      <ul className="Features25__committeeList">
        {element.map((employee) => (
          <li key={employee.id}>
            <Employee content={employee} />
          </li>
        ))}
      </ul>
    </StyledCommittee>
  );
}, {});

const StyledCommittee = styled.div`
  flex: 0 0 424px;
  display: flex;
  flex-direction: column;
  margin-left: 64px;
  padding: 40px;
  box-shadow: inset 0 0 0 1px ${({ theme }) => theme.colors.fog["30"]};
  border-radius: 8px;

  .Features25__committeeTitle {
    padding-bottom: 11px;
    border-bottom: 1px solid #e4e4e4;
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.xl}px`}) {
    flex-basis: 371px;
    align-self: flex-end;
    padding: 24px;
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.lg}px`}) {
    display: none;
  }
`;

gql`
  fragment Features25CommitteeContent on ComponentNestedFeatures25ComitteeList {
    title
    element {
      ...Features25EmployeeContent
    }
  }
`;

export { Committee };
